import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ErrorDisplay, DataField, interfaces } from '../../common';
import { fetchDailyActiveUsers } from '../actions';
import { Status } from '../../constants';

export const DailyActiveUsers = () => {
  const { dashboard }: interfaces.IGlobalStoreState = useSelector(
    (state: interfaces.IGlobalStoreState) => state
  );
  const { dailyActiveUsers, status, error } = dashboard.dailyActiveUsers;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDailyActiveUsers());
  }, [dispatch]);

  return (
    <div>
      <DataField>
        <h4>Daily Active Users</h4>
        <h3>{status === Status.Loading ? `—` : dailyActiveUsers.length}</h3>
      </DataField>
      <ErrorDisplay errorMessage={error} />
    </div>
  );
};
